import React, { Component } from 'react';
import golbeldata from '../data.json';
import { Link, Route, Switch } from 'react-router-dom';

class AppFooter extends Component { 

  componentDidMount() { 
    
  }
      render() {        
        return ( <footer>
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-sm-4">
                        <h4>About {this.props.data.HotelName}</h4>
                        <p>Salasar Balaji or Salasar Dham in India is a place of religious importance for the devotees of Hanuman. It is located in the town of Salasar, on National Highway 65 near Sujangarh in Churu district, Rajasthan. The temple of Balaji founded by a Jat is situated in the middle of Salasar and attracts innumerable worshippers throughout the year. On Chaitra Purnima and Ashvin Purnima, large fairs are organised that attract devotees as they pay homage to the deity.  <br />
                         </p>
                    </div>
                    <div class="col-md-4 col-sm-4">
                        <h4>Recieve our newsletter</h4>
                        
                        <form role="form">
                            <div class="form-group">
                                <input name="newsletter" type="text" id="newsletter" value="" class="form-control" placeholder="Please enter your E-mailaddress" />
                            </div>
                            <button type="submit" class="btn btn-lg btn-black btn-block">Submit</button>
                        </form>
                    </div>
                    <div class="col-md-4 col-sm-4">
                        <h4>Address</h4>
                        <address>
                            <strong>{this.props.data.HotelName}</strong><br />
                            {this.props.data.addressline1}<br />
                            {this.props.data.addressline2}<br />
                            <abbr title="Phone">P:</abbr> <a href="#">{this.props.data.phone}</a><br />
                            <abbr title="Email">E:</abbr> <a href="#">{this.props.data.Email}</a><br />
                            <abbr title="Website">W:</abbr> <a href="#">{this.props.data.Webiste}</a><br />
                        </address>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-6"> &copy; 2014 {this.props.data.HotelName} All Rights Reserved </div>
                        <div class="col-xs-6 text-right">
                            <ul>
                                <li><Link to="/contact"> Contact </Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>)
        }
    }
    export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/Footer.js